export default __webpack_public_path__ + "static/media/H1015.3.64ad32d7.mp3";